export enum CheckoutStepsEnum {
  overview = 0,
  shipping = 1,
  payments = 2,
  donations = 3,
  recap = 4
}
